import {useTranslation} from "react-i18next"
import {parseISO} from "date-fns"

import {TKlaraPeriod, TKlaraPreset} from "../period"
import {formatDate} from "./formatDate"

/** "1 Oct – 16 Oct", with years when either end is outside the current year. */
export const formatRange = (from: string, to: string) => {
  const fromDate = parseISO(from)
  const toDate = parseISO(to)
  const thisYear = new Date().getFullYear()
  const pattern = fromDate.getFullYear() !== thisYear || toDate.getFullYear() !== thisYear ? "d MMM yyyy" : "d MMM"
  return `${formatDate(fromDate.getTime(), pattern)} – ${formatDate(toDate.getTime(), pattern)}`
}

export const usePresetLabels = (): Record<TKlaraPreset, string> => {
  const {t} = useTranslation()

  return {
    "7d": t("KlaraDashboard_Period_7d"),
    "30d": t("KlaraDashboard_Period_30d"),
    "90d": t("KlaraDashboard_Period_90d"),
    lifetime: t("KlaraDashboard_Period_Lifetime"),
  }
}

/** The period as the picker names it: the preset's label or the custom range. */
export const usePeriodLabel = (period: TKlaraPeriod): string => {
  const labels = usePresetLabels()

  return period.kind === "custom" ? formatRange(period.from, period.to) : labels[period.preset]
}
